import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import CreateProjectButton from './CreateProjectButton';
import { t } from '../i18n';


const SearchInput = ({ placeholder, style }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  // Utility to get API base URL depending on environment
  const getApiBaseUrl = () => {
    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      return 'http://localhost:3000';
    }
    // Use relative URL for production
    return '';
  };

  // Utility to create a slug from a string (same as backend)
  function slugify(text) {
    return text
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .toLowerCase();
  }

  const handleSearch = (term) => {
    const query = typeof term === 'string' ? term : searchTerm;
    if (!query.trim()) return;
    fetch(`${getApiBaseUrl()}/api/objects/search?name=${encodeURIComponent(query)}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          // Use slug for navigation
          const slug = slugify(data[0].name);
          navigate(`/objets/${slug}`);
        } else {
          navigate('/no-results', { state: { searchTerm: query } });
        }
      })
      .catch((error) => console.error('Error searching for objects:', error));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };


  // Suggested search terms (dynamically fetched from API)
  const [suggestions, setSuggestions] = useState([]);
  useEffect(() => {
    fetch(`${getApiBaseUrl()}/api/objects`)
      .then((response) => response.json())
      .then((data) => {
        // Sort by popularity if available, else alphabetically, and take the first 3
        let sorted = data;
        if (Array.isArray(data)) {
          if (data[0] && typeof data[0].popularity !== 'undefined') {
            sorted = data.sort((a, b) => b.popularity - a.popularity);
          } else {
            sorted = data.sort((a, b) => a.name.localeCompare(b.name));
          }
          setSuggestions(sorted.slice(0, 3).map(obj => obj.name));
        }
      })
      .catch(() => setSuggestions([]));
  }, []);

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={styles.inputContainer}>
        <input
          type="text"
          placeholder={t('searchPlaceholder') || placeholder || 'Rechercher...'}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{
            ...styles.input,
            ...style,
          }}
        />
        <button
          onClick={() => handleSearch()}
          style={styles.searchButton}
          className="searchButtonCustom"
        >
          {t('searchButton') || 'Aidez moi !'}
        </button>
      </div>
      {/* Suggestions */}
      <div style={styles.suggestionsContainer}>
        {suggestions.map((term, idx) => (
          <button
            key={term}
            style={styles.suggestionButton}
            onClick={() => handleSearch(term)}
            type="button"
          >
            {term}
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  inputContainer: {
    display: 'flex',
    flexDirection: 'column', // Stack input and button vertically
    alignItems: 'center', // Center items horizontally
    gap: '10px', // Space between the input and button
    marginBottom: '0', // Remove extra space below the button
    width: '100%', // Full width for the container
  },
  input: {
    width: '80%', // Increased width for better usability
    maxWidth: 500,
    minWidth: 220,
    padding: '10px',
    fontSize: '16px',
    border: '1px solid var(--gray-anthracite)',
    backgroundColor: 'var(--beige-sand)',
    borderRadius: '5px',
    outline: 'none',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },
  searchButton: {
    width: 'auto', // Adjust width to fit content
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: 'var(--green-eucalyptus)',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '5px', // Remove extra space above the button
  },
  suggestionsContainer: {
    marginTop: 10,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'center',
  },
  suggestionButton: {
    background: '#f3f3f3',
    color: '#222',
    border: '1px solid #ddd',
    borderRadius: 5,
    padding: '6px 14px',
    fontSize: 15,
    cursor: 'pointer',
    transition: 'background 0.2s, color 0.2s',
    marginBottom: 4,
  },
  createProjectContainer: {
    marginTop: '5px',
    textAlign: 'center',
  },
  createProjectButton: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: 'var(--green-eucalyptus)',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default SearchInput;

// Add CSS for hover effect
const styleSheet = document.createElement('style');
styleSheet.type = 'text/css';
styleSheet.innerText = `
  .searchButtonCustom:hover {
    background-color: #27ae60 !important;
    filter: brightness(0.95);
    transition: background 0.2s, filter 0.2s;
  }
`;
if (typeof document !== 'undefined') {
  document.head.appendChild(styleSheet);
}